<script>
  import { DropdownMenu } from 'bits-ui'
  import { Check } from 'lucide-svelte'
  import TriggerButton from '@components/shared/trigger-button.svelte';
  // import { Link } from '@inertiajs/svelte'
  import { cn } from '@lib/utils'
  
  let { 
    open = $bindable(false),
    disabled = false,
    text,
    trigger,
    contents,
    buttonClass,
    rootClass = '',
    contentClass = 'z-[60]',
    width = '18rem',
    offset = 10,
    align = 'end',
    side = 'bottom',
    textAlign = 'left',
    Icon,
    iconSize = 16,
    iconClass,
    buttonHint,
    closeOnSelect = true 
  } = $props()
  
  let itemClass = `flex items-center justify-between text-gray-600 text-[12px] px-4 py-3 cursor-pointer hover:bg-blue-50 relative`
  let itemStyle = $derived(`width: ${width}`)

  function handleEscapeKeydown(event) {
    event.preventDefault() // This stops other window escape behaviour higher up also closing other modals etc
  }
</script>

{#snippet item(item)}
  {@const shouldClose = item.closeOnSelect ?? closeOnSelect}
  <DropdownMenu.Item textValue={item.text}>
    {#snippet child(props)}
      {#if item.path}
        <a href={item.path} onclick={() => {shouldClose && (open = false)}} {...props} class={cn(itemClass, item.disabled ? "opacity-50 cursor-not-allowed" : "")} style={itemStyle}>
          <div class="flex items-center gap-2">
            <item.icon size={13} class="text-gray-400 mr-2" />
            {item.text}
          </div>
          {#if item.selected}
            <Check size={13} class="text-gray-400" />
          {/if}
        </a>
      {:else}
        <button type="button" disabled={item.disabled} onclick={() => {item.onSelect?.(); shouldClose && (open = false)}} {...props} class={cn(itemClass, item.disabled ? "opacity-50 cursor-not-allowed" : "")} style={itemStyle}>
          <div class="flex items-center gap-2">
            <item.icon size={13} class="text-gray-400 mr-2" />
            {item.text}
          </div>
          {#if item.selected}
            <Check size={13} class="text-gray-400" />
          {/if}
        </button>
      {/if}
    {/snippet}
  </DropdownMenu.Item>
{/snippet}

<div class={rootClass}>
  
  <DropdownMenu.Root bind:open>

    <DropdownMenu.Trigger {disabled}>
      {#if trigger}
        {@render trigger({ open })}
      {:else}
        <TriggerButton {disabled} {open} {text} {Icon} class={buttonClass} {iconSize} {iconClass} hint={buttonHint} />
      {/if}
    </DropdownMenu.Trigger>

    <DropdownMenu.Portal>

      <DropdownMenu.Content class={cn(`bg-white shadow-xl border border-gray-200/60 rounded-md py-2`, contentClass)} {align} {side} sideOffset={offset} onEscapeKeydown={handleEscapeKeydown}>
        <DropdownMenu.Group class="divide-y divide-gray-100">
          {@render contents?.(item)}
        </DropdownMenu.Group>
      </DropdownMenu.Content>

    </DropdownMenu.Portal>

  </DropdownMenu.Root>

</div>